"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var ToolBarDateRangeFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarDateRangeFilter");
var ToolBarBrandFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarBrandFilter");
var alasql = require("alasql");
var ButtonDoExportXLS_1 = require("../../../../../../shared/components/buttons/ButtonDoExportXLS");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var RepTotalProfitList = /** @class */ (function (_super) {
    __extends(RepTotalProfitList, _super);
    function RepTotalProfitList(props) {
        var _this = _super.call(this, props) || this;
        _this.columns = [
            {
                title: 'Партнер',
                dataIndex: _this.props.data.dk_usr_partner_login,
                key: _this.props.data.dk_usr_partner_login,
                width: 250,
                render: function (text, record, idx) {
                    if (!record.total) {
                        if (record.is_own_brand_partner) {
                            return (React.createElement("div", { style: { color: "green" } },
                                React.createElement("b", null,
                                    React.createElement("span", null,
                                        React.createElement(FontAwesome_1.FA, { right: true, icon: "user-check" })),
                                    " ",
                                    record.usr_partner_login)));
                        }
                        else {
                            return (React.createElement("div", null,
                                React.createElement("span", { style: { color: "gray" } },
                                    React.createElement(FontAwesome_1.FA, { right: true, icon: "user-tie" })),
                                " ",
                                record.usr_partner_login));
                        }
                    }
                    else {
                        return (React.createElement("div", null,
                            React.createElement("b", null, record.usr_partner_login)));
                    }
                }
            }, {
                title: 'Количество',
                children: [{
                        title: 'Депозитов',
                        dataIndex: _this.props.data.dk_total_deposits_count,
                        key: _this.props.data.dk_total_deposits_count,
                        width: 150,
                    }, {
                        title: 'Снятий',
                        dataIndex: _this.props.data.dk_total_withdraws_count,
                        key: _this.props.data.dk_total_withdraws_count,
                        width: 150,
                    }]
            }, {
                title: 'Сумма операций',
                children: [{
                        title: 'Пополнений',
                        dataIndex: _this.props.data.dk_total_deposit_amount,
                        key: _this.props.data.dk_total_deposit_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                new Intl.NumberFormat().format(record.total_deposit_amount),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }, {
                        title: 'Снятий',
                        dataIndex: _this.props.data.dk_total_withdraw_amount,
                        key: _this.props.data.dk_total_withdraw_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                new Intl.NumberFormat().format(record.total_withdraw_amount),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }]
            }, {
                title: 'Сумма ставок',
                children: [{
                        title: 'Ставок',
                        dataIndex: _this.props.data.dk_total_bet_money_amount,
                        key: _this.props.data.dk_total_bet_money_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                record.total_bet_money_amount.toFixed(2),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }, {
                        title: 'Выигрышей',
                        dataIndex: _this.props.data.dk_total_win_money_amount,
                        key: _this.props.data.dk_total_win_money_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                record.total_win_money_amount.toFixed(2),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }]
            }, {
                title: 'Бонусы',
                children: [{
                        title: 'Количество',
                        dataIndex: _this.props.data.dk_total_completed_bonus_count,
                        key: _this.props.data.dk_total_completed_bonus_count,
                        width: 150,
                    }, {
                        title: 'Сумма',
                        dataIndex: _this.props.data.dk_total_completed_bonus_amount,
                        key: _this.props.data.dk_total_completed_bonus_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                new Intl.NumberFormat().format(record.total_completed_bonus_amount),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }]
            }, {
                title: 'Доход',
                children: [{
                        title: 'Партнера',
                        dataIndex: _this.props.data.dk_total_own_partner_profit_amount,
                        key: _this.props.data.dk_total_own_partner_profit_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                new Intl.NumberFormat().format(record.total_own_partner_profit_amount),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }, {
                        title: 'Субпартнера',
                        dataIndex: _this.props.data.dk_total_sub_partner_profit_amount,
                        key: _this.props.data.dk_total_sub_partner_profit_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                new Intl.NumberFormat().format(record.total_sub_partner_profit_amount),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }, {
                        title: 'Бренда',
                        dataIndex: _this.props.data.dk_total_brand_profit_amount,
                        key: _this.props.data.dk_total_brand_profit_amount,
                        width: 150,
                        render: function (text, record, idx) {
                            return (React.createElement("div", null,
                                new Intl.NumberFormat().format(_this.getRealBrandProfit(record)),
                                " ",
                                _this.props.data.DATA.app_currency_symbol));
                        }
                    }]
            }
        ];
        return _this;
    }
    RepTotalProfitList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data,
                totalRows: data.total_count
            });
        });
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({
                dtFrom: data.dtFrom,
                dtTo: data.dtTo,
                dtFormat: data.dtTimeFormat
            }, function () {
                _this.loadData(_this.props);
            });
        });
        this.setState({
            data: this.props.data.DATA,
            pageNum: this.props.pageNum,
            pageSize: this.props.pageSize,
            totalRows: 0,
            dtFrom: this.props.state.getDateFrom(),
            dtTo: this.props.state.getDateTo(),
            dtFormat: this.props.state.getDateTimeFormat(),
            is_skip_zero_partners: true,
            selected_currency_id: this.props.state.getCurrencyId()
        }, function () {
            //alert(`${this.props.state.getCurrencyId()} <-> ${this.props.state.getOrgId()}`);
            _this.loadData(_this.props);
        });
        this.props.state.setExtBreadCrumbPath([]);
    };
    RepTotalProfitList.prototype.getDefaultAppCurrencyId = function () {
        if (this.props.availCurrency.length > 0) {
            return this.props.availCurrency[0].key;
        }
        else {
            return 0;
        }
    };
    RepTotalProfitList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
        this.props.state.UnSubscribe(this.SID_STATE);
    };
    RepTotalProfitList.prototype.componentWillReceiveProps = function (nextProps) {
        var _this = this;
        if (nextProps) {
            this.setState({
                pageNum: nextProps.pageNum,
                pageSize: nextProps.pageSize,
            }, function () {
                _this.loadData(nextProps);
            });
        }
    };
    RepTotalProfitList.prototype.loadData = function (Props, onDone) {
        Props.data.LoadData({
            from_year: this.state.dtFrom.get('year'),
            from_month: this.state.dtFrom.get('month') + 1,
            from_day: this.state.dtFrom.get('date'),
            to_year: this.state.dtTo.get('year'),
            to_month: this.state.dtTo.get('month') + 1,
            to_day: this.state.dtTo.get('date'),
            brands_id_list: this.props.brandsList,
            all_brands: this.props.allBrands,
            app_currency_id: this.state.selected_currency_id,
            skip_zero_partners: this.state.is_skip_zero_partners
        }, function () {
            if (onDone) {
                onDone();
            }
        });
    };
    RepTotalProfitList.prototype.getRealBrandProfit = function (record) {
        var tmp = record.total_brand_profit_amount - record.total_sub_partner_profit_amount;
        return tmp; //.toFixed(2);
    };
    RepTotalProfitList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.loadData(this.props);
        }
    };
    RepTotalProfitList.prototype.onSelectRange = function (DtFrom, DtTo) {
        this.props.state.setDateFrom(DtFrom).setDateTo(DtTo, true);
    };
    RepTotalProfitList.prototype.onOfferFilterChanged = function (allBrands, BrandId, Action) {
        if (this.props.onOfferFilterChanged) {
            this.props.onOfferFilterChanged(allBrands, BrandId, Action);
        }
    };
    RepTotalProfitList.prototype.doExportPlayers = function () {
        var _this = this;
        this.props.dlgExportList
            .clearFields()
            .SetDialogTitle("Экспорт отчета")
            .SetOnYesClick(function (exportFormat) {
            _this.props.data.doExportObjectArray({
                from_year: _this.state.dtFrom.get('year'),
                from_month: _this.state.dtFrom.get('month') + 1,
                from_day: _this.state.dtFrom.get('date'),
                to_year: _this.state.dtTo.get('year'),
                to_month: _this.state.dtTo.get('month') + 1,
                to_day: _this.state.dtTo.get('date'),
                brands_id_list: _this.props.brandsList,
                all_brands: _this.props.allBrands,
                app_currency_id: _this.state.selected_currency_id,
                skip_zero_partners: _this.state.is_skip_zero_partners
            }, function (data) {
                if (exportFormat === "XLSX") {
                    var opts = [{ sheetid: 'Exported report data', header: true }];
                    var result = alasql('SELECT * INTO XLSX("exported_report_data.xlsx",?) FROM ?', [opts, [data]]);
                }
                if (exportFormat === "CSV") {
                    var result = alasql('SELECT * INTO CSV("exported_report_data.csv", {headers:true}) FROM ?', [data]);
                }
                if (exportFormat === "JSON") {
                    var result = alasql('SELECT * INTO JSON("exported_report_data.json", {headers:false}) FROM ?', [data]);
                }
                if (exportFormat === "TXT") {
                    var result = alasql('SELECT * INTO TAB("exported_report_data.txt", {headers:true}) FROM ?', [data]);
                }
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                    "\u042D\u043A\u0441\u043F\u043E\u0440\u0442 \u0432 \u0444\u043E\u0440\u043C\u0430\u0442\u0435 ",
                    React.createElement("b", null,
                        "[",
                        exportFormat,
                        "]"),
                    " \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D !"));
            });
        }).Show();
    };
    RepTotalProfitList.prototype.onCheckBoxChecked = function (checked) {
        this.setState({ is_skip_zero_partners: checked });
    };
    RepTotalProfitList.prototype.getCurrencyISO = function (id) {
        for (var i = 0; i < this.props.availCurrency.length; i++) {
            if (this.props.availCurrency[i].key == id) {
                return this.props.availCurrency[i].value;
            }
        }
        return "";
    };
    RepTotalProfitList.prototype.getCurrencyValue = function () {
        if (this.state.selected_currency_id === 0) {
            return undefined;
        }
        else {
            return {
                key: this.state.selected_currency_id.toString(),
                label: this.getCurrencyISO(this.state.selected_currency_id)
            };
        }
    };
    RepTotalProfitList.prototype.getSelectCurrencyItems = function () {
        var _ret = [];
        for (var i = 0; i < this.props.availCurrency.length; i++) {
            _ret.push(React.createElement(antd_1.Select.Option, { key: "" + i, value: "" + this.props.availCurrency[i].key }, this.props.availCurrency[i].value));
        }
        return _ret;
    };
    RepTotalProfitList.prototype.onCurrencyValueChange = function (value, option) {
        var _this = this;
        this.setState({
            selected_currency_id: parseInt(value.key)
        }, function () {
            //this.props.state.setAllCurrency(allCurrency, true);
            _this.props.state.setCurrencyId(_this.state.selected_currency_id, true);
        });
    };
    RepTotalProfitList.prototype.onPageChanged = function (Page, PageSize) {
        var _this = this;
        var _page = Page;
        if (PageSize != this.state.pageSize) {
            _page = 1;
        }
        var _PageSize = this.state.pageSize;
        if (PageSize) {
            _PageSize = PageSize;
        }
        this.setState({ pageNum: _page, pageSize: _PageSize }, function () {
            _this.props.state.setTablePageSize(PageSize, true);
            _this.loadData(_this.props);
            // if (this.props.onPageConfigChanged) {
            //   this.props.onPageConfigChanged(_page, _PageSize);
            // }
        });
    };
    RepTotalProfitList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(ButtonDoExportXLS_1.default, { hint: "Экспорт списка", onClick: function () { _this.doExportPlayers(); } }),
                React.createElement(ToolBarDateRangeFilter_1.default, { title: "\u0414\u0438\u0430\u043F\u0430\u0437\u043E\u043D \u0434\u0430\u0442: ", from: { date: this.state.dtFrom, title: "Начало" }, to: { date: this.state.dtTo, title: "Окончание" }, onClick: this.onSelectRange.bind(this) }),
                React.createElement("div", { style: { marginLeft: "5px", marginRight: "5px", whiteSpace: "nowrap" } }, "\u0412\u0430\u043B\u044E\u0442\u0430 \u043E\u0442\u0447\u0435\u0442\u0430"),
                React.createElement(antd_1.Select, { style: { width: "100px", marginLeft: "5px", marginRight: "2px" }, showSearch: true, 
                    // placeholder={this.props.captions.placeholderYear}
                    optionFilterProp: "children", filterOption: function (input, option) {
                        return option.props.children.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0;
                    }, onChange: this.onCurrencyValueChange.bind(this), labelInValue: true, value: this.getCurrencyValue() }, this.getSelectCurrencyItems()),
                React.createElement("div", { style: { marginLeft: "5px", marginRight: "5px", whiteSpace: "nowrap" } }, "\u0421\u043A\u0440\u044B\u0442\u044C \u043D\u0443\u043B\u0435\u0432\u044B\u0445 \u043F\u0430\u0440\u0442\u043D\u0435\u0440\u043E\u0432"),
                React.createElement(antd_1.Switch, { checked: this.state.is_skip_zero_partners, onChange: this.onCheckBoxChecked.bind(this) }),
                React.createElement(ToolBarBrandFilter_1.default, { allBrands: this.props.allBrands, availBrands: this.props.availBrands, captions: { checkbox: "Все бренды", placeholder: "Выберите бренд" }, selectedBrands: this.props.brandsList, onBrandFilterChanged: this.onOfferFilterChanged.bind(this) })),
            React.createElement("div", { style: { overflowX: "auto" } },
                React.createElement(antd_1.Table, { locale: {
                        filterTitle: 'Поиск',
                        filterConfirm: 'Да',
                        filterReset: 'Сброс',
                        emptyText: 'Нет данных',
                    }, bordered: true, columns: this.columns, dataSource: this.state.data.data, pagination: {
                        pageSize: this.state.pageSize,
                        showSizeChanger: true,
                        current: this.state.pageNum,
                        total: this.state.totalRows,
                        position: "top",
                        onChange: this.onPageChanged.bind(this),
                        onShowSizeChange: this.onPageChanged.bind(this),
                        pageSizeOptions: this.props.state.UITablePageSizeOptions,
                        showQuickJumper: true,
                    }, style: { overflowX: "clip", minWidth: "2000px" }, scroll: { y: "calc( 100vh - 375px )", x: false } }),
                React.createElement(antd_1.Table, { locale: {
                        filterTitle: 'Поиск',
                        filterConfirm: 'Да',
                        filterReset: 'Сброс',
                        emptyText: 'Нет данных',
                    }, bordered: true, columns: this.columns, dataSource: this.state.data.data_total, pagination: false, showHeader: false, style: { overflowX: "clip", minWidth: "2000px" }, rowClassName: function (record) {
                        if (record.total) {
                            return "summary-table-row";
                        }
                        else {
                            return "";
                        }
                    }, scroll: { y: "75px" } }))));
    };
    return RepTotalProfitList;
}(React.Component));
exports.default = RepTotalProfitList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/rep_total_profit/ui/component/RepTotalProfitList.tsx
// module id = 2488
// module chunks = 0